import React from 'react'

import { cn } from '@/lib/utils.ts'
import { SpinnerIcon } from '@/components/spinner/spinner-icon.tsx'

export interface LoadingSpinnerProps {
  className?: string
  wrapperClassName?: string
  children?: React.ReactNode
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  className,
  wrapperClassName,
  children,
}) => {
  return (
    <div
      className={cn(
        wrapperClassName,
        'flex h-full grow flex-col items-center justify-center gap-4'
      )}
    >
      <SpinnerIcon className={className} />
      {children}
    </div>
  )
}
